/**
 * Converts an Optimizely locale string to the standard intl locale format used across the app.
 */
export const mapOptimizelyLocaleToIntlLocale = (locale: string) => {
  if (locale.toLocaleLowerCase() === 'zh-cht') {
    return 'zh-Hant';
  }

  if (locale.toLocaleLowerCase() === 'zh-cn') {
    return 'zh-Hans';
  }

  return locale;
};
